import { withStyles } from '@material-ui/core';

const styles = withStyles(() => ({
  containerWithoutInput: {
    display: 'flex',
    padding: '8px 0',
    position: 'relative',
    '& > div': {
      padding: 0,
      marginLeft: 16,
      border: 'none',
      height: 'unset',
      minWidth: 'unset',
    },
    '& button': {
      padding: 0,
    },
  },
}));

export default styles;
